// auto-generated file. do not edit manually.
export type IconName = 'add' | 'checkmark' | 'chevron-down' | 'clipboard' | 'document' | 'download' | 'edit' | 'magicpen' | 'new-arrow-down' | 'new-arrow-up' | 'order';
export const iconNames: IconName[] = [
	'add',
	'checkmark',
	'chevron-down',
	'clipboard',
	'document',
	'download',
	'edit',
	'magicpen',
	'new-arrow-down',
	'new-arrow-up',
	'order'
]
